import {Typography} from '@mui/material';

import FlagButton from '../../FlagButton';
import makeStyles from '@mui/styles/makeStyles';
import WatchedButton from '../../Buttons/WatchedButton';
import AddToMyListButton from '../../Buttons/AddToMyListButton';
import Metadata from '../Metadata';
import { memo } from 'react';
import ImageLoadIfVisible from '../../Utils/ImageLoadIfVisible';
import RenderIfVisible from '../../Utils/RenderIfVisible';

import "./GridViewEntryListItem.scss";
import BrokenImage from '../../Utils/BrokenImage';
import { entryIsInMyListFor, entryIsWatchedFor } from '../../../Utils/Entry';

const useStyles = makeStyles(theme => ({
    hoveredRoot: {
        opacity: 0,
        pointerEvents: "none",

        position: 'absolute',
        zIndex: 1,
        top: 0, left: 0, right: 0,

        '& .MuiButtonBase-root': {
            backgroundColor: '#323232',
        },
        [theme.breakpoints.up('sm')]: {
            '&:hover, &:focus, &:focus-within, $imageWrap:hover+&, $imageWrap:focus+&': {
                opacity: 1,
                pointerEvents: "initial",
            }
        },
        '& .cardContent': {
            display: 'block'
        },
        '& .MuiButtonBase-root .MuiPaper-root .MuiCard-root .MuiCardContent-root': {
            backgroundColor: '#323232',
        },
    },
    imageWrap: {
        display: "block",
        position: "relative",
        border: '1px solid transparent',
    },
    image: {
        width: '100%',
        display: 'block',
    },
    imageWrapHover: {
        display: "block",
        position: "relative",
        color: theme.palette.secondary.contrastText,
        textDecoration: 'none',
        border: '1px solid '+theme.palette.primary.main,
    },
    imageHovered: {
    },
    actionArea: {
        display: "flex",
        flexWrap: "wrap",
        gap: "1rem",
    },
    actionButton: {
        flexGrow: 1,
    },
    entryTitle: {
        paddingBottom : theme.spacing(1.5),
        paddingTop : theme.spacing(2),
        clear: 'both'
    },
    entryInfo : {
        '& p span': {
            marginLeft: '10px',
            marginRight: '10px'
        },
        '&:hover':{
            display: 'block'
        }
    },
    flags: {
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
        '& div':{
            marginRight: theme.spacing(1.2)
        }
    },
    mandatoryFlag: {
        position: "absolute",
        top: '0',
        left: '0',
        padding: ".25rem",
        maxWidth: "100%",

        [theme.breakpoints.up('sm')]: {
            padding: "1rem",
        },
    },
}));

export default memo(function GridViewEntryListItem({ linkComponent, entry, categoryId = null, categoryName = null }) {
    const classes = useStyles();

    const awardId = entry.awardId;

    const isInMyList = entryIsInMyListFor(entry, categoryId);
    const isWatched = entryIsWatchedFor(entry, categoryId);

    const LinkComponent = linkComponent;

    return (
        <div className="GridViewEntryListItem">
            <LinkComponent entry={entry} entryCategoryId={categoryId} className={classes.imageWrap}>
                {entry.primaryImage ? (
                    <ImageLoadIfVisible
                        className={classes.image}
                        src={entry.primaryImage}
                        alt={entry.title}
                    />
                ):(
                    <BrokenImage />
                )}
                {entry.isMandatory &&
                    <div className={classes.mandatoryFlag}>
                        <FlagButton className="GridViewEntryListItem__mandatoryflag" variant="mandatory" />
                    </div>
                }
            </LinkComponent>
            <RenderIfVisible className={classes.hoveredRoot + ` GridViewEntryListItem__hover`}>
                <LinkComponent entry={entry} entryCategoryId={categoryId} className={`${classes.imageWrap} ${classes.imageWrapHover}`}>
                    {entry.primaryImage ? (
                        <img
                            className={`${classes.image} ${classes.imageHovered} GridViewEntryListItem__hoverimg`}
                            src={entry.primaryImage}
                            alt={entry.title}
                        />
                    ):(
                        <BrokenImage className={`${classes.image} ${classes.imageHovered} GridViewEntryListItem__hoverimg`} />
                    )}
                    {entry.isMandatory && (
                        <div className={classes.mandatoryFlag}>
                            <FlagButton variant="mandatory" />
                        </div>
                    )}
                </LinkComponent>
                <div className={`${classes.entryTitle} cardContent`}>
                    <Typography gutterBottom variant="h5" component={LinkComponent} entry={entry} className="GridViewEntryListItem__title">
                        {entry.title}
                        {categoryId && categoryName && ` (${categoryName})`}    
                    </Typography>
                    <Metadata entry={entry} />
                    <div className={classes.flags}>
                        {entry.certification && (
                            <FlagButton variant={entry.certification.answer} />
                        )}
                    </div>
                    <div className={classes.actionArea}>
                        <WatchedButton 
                            awardId={awardId}
                            entry={entry}
                            label={entry.judgingMediaType === 'video' ? "Watched" : "Played"}
                            isOn={isWatched}
                            categoryId={categoryId}
                        />
                        <AddToMyListButton
                            awardId={awardId}
                            categoryId={categoryId}
                            entry={entry}
                            isOn={isInMyList}
                        />
                    </div>
                </div>
            </RenderIfVisible>
        </div>
    );
});